module.exports = __webpack_public_path__ + "static/img/scene-3.6ac8976b.jpg";